import { ptBR } from '@/i18n/pt-BR';
import { MonoData } from '@/components/ui';

const t = ptBR.documentoBaixado;

export interface CodigoDoArquivoBaixadoProps {
  /** O SHA-256 lido do cabeçalho do download; `null` esconde o bloco. */
  codigo: string | null;
}

/**
 * O código de verificação do arquivo que acabou de descer (E85.F2 — GUS-32). // ux-neutrality:allow doc-comment
 *
 * Inteiro, e não abreviado: é o valor que a pessoa compara com a conta feita // ux-neutrality:allow doc-comment
 * sobre o arquivo salvo, e uma abreviação aqui só serviria para não bater. // ux-neutrality:allow doc-comment
 */
export function CodigoDoArquivoBaixado({
  codigo,
}: CodigoDoArquivoBaixadoProps): JSX.Element | null {
  if (codigo === null) return null;
  return (
    <p
      role="status"
      className="mt-sc-2 max-w-3xl text-caption text-fg-muted"
      data-testid="codigo-do-arquivo-baixado"
    >
      <span>{t.rotulo}</span>{' '}
      <MonoData className="break-all text-fg" data-testid="codigo-do-arquivo-baixado-valor">
        {codigo}
      </MonoData>
      <span className="block">{t.nota}</span>
    </p>
  );
}
